import React, { useState } from 'react'
import { ErrorMessage } from 'formik'
import ErrorRow from './ErrorRow'
import classNames from 'classnames'
import { ReactComponent as PasswordIcon } from '../../../../assets/svg/actions/icn-eye.svg'
import InputMask from "react-input-mask";
import Tools from "../../../../Tools";

/**
 *
 * @param {object} field
 * @description contain { onChange, onBlur, name, value }
 * @link https://jaredpalmer.com/formik/docs/api/useField#fieldinputpropsvalue
 *
 * @param {object} meta
 * @description contain { value, touched, error, initialValue }
 * @link https://jaredpalmer.com/formik/docs/api/useField#fieldmetapropsvalue
 *
 * @param {object} form
 *
 */
export const Input = ({
    field,
    form,
    label,
    children,
    icon: Icon = () => null,
    customError: ErrorComponent,
    mask, // react-input-mask
    errorMessagePosition,
    withoutMargin,
    groupClassName,
    absolutError = false,
    ...props
}) => {
    const { name } = field;
    const { disabled = false, type = "text" } = props;
    const [inputType, setInputType] = useState(type);
    const isValid = !(form.errors[name] && form.touched[name]);
    Icon = type === "password" ? PasswordIcon : Icon;

    const togglePassword = () => setInputType(prevType => prevType === "password" ? "text" : "password");

    const Component = mask ? InputMask : 'input';

    return (
        <div className={classNames(
            "form-group", 
            groupClassName, 
            errorMessagePosition && `error-position-${errorMessagePosition}`, 
            { 
                'form-error': !isValid, 
                'form-disabled': disabled, 
                'without-margin': withoutMargin,
                'absolut-error': absolutError
            }
        )}>
            <div className={classNames("form-info")}>
                <label htmlFor={name}>{label}</label>
                {ErrorComponent ?
                    <ErrorComponent /> :
                    <ErrorMessage name={name} component={ErrorRow} />}
            </div>
            <div className="form-input">
                <Component {...field} {...props} mask={mask} type={inputType} />
                <Icon className={classNames("form-icon right", { active: inputType !== "password" })} onClick={togglePassword} />
            </div>
        </div>
    );
};
